import grangeColombeIcon from "../../../assets/icons/grange-colombe.jpg"
import lionsIcon from "../../../assets/icons/lions.png"
import reineAstridIcon from "../../../assets/icons/la-reine-astrid.png"
import smartCityIcon from "../../../assets/icons/smartCity.svg"

function createTrustedInfoArray() {
  return [
    {
      src: grangeColombeIcon,
      alt: "Icône grange colombe",
      link: "https://mfr-rambouillet.fr/",
    },
    {
      src: lionsIcon,
      alt: "Icône lions club",
      link: "https://www.lionsclubs.org/fr",
    },
    {
      src: reineAstridIcon,
      alt: "Icône reine Astrid",
      link: "https://www.alareineastrid.fr/",
    },
    {
      src: smartCityIcon,
      alt: "smartCityIcon",
      link: "https://www.smartcitycampus.fr/",
    },
  ]
}

export default createTrustedInfoArray()
